// Credits: https://javascript.info/blob
/** @param {string | undefined} target */
export const triggerDownloadBlob = (data, mimeType, filename, target = undefined) => {
  const link = document.createElement('a')
  const blob = new Blob([data], { type: mimeType })

  if (filename) {
    link.download = filename
  }

  if (target) {
    link.target = target
  }
  link.href = URL.createObjectURL(blob)
  link.click()

  URL.revokeObjectURL(link.href)
}

export const printBlob = (data, mimeType) => {
  const blob = new Blob([data], { type: mimeType })
  const url = URL.createObjectURL(blob)

  const iframe = document.createElement('iframe')
  iframe.style.position = 'fixed'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.src = url

  const cleanup = () => {
    document.body.removeChild(iframe)
    URL.revokeObjectURL(url)
  }

  iframe.onload = () => {
    iframe.contentWindow.focus()
    iframe.contentWindow.print()
    iframe.contentWindow.onafterprint = cleanup
  }

  document.body.appendChild(iframe)
}
